<template>
  <b-modal
    :visible="show"
    title="Modo mantenimiento"
    ok-title="Guardar"
    cancel-title="Cancelar"
    @ok.prevent="guardar"
    @hidden="$emit('closeModal')"
    @shown="cargar"
  >
    <b-form-checkbox v-model="activo" switch class="mb-2">
      Activar modo mantenimiento (bloquea a los no administradores)
    </b-form-checkbox>

    <b-form-group label="Mensaje mostrado a los no administradores">
      <b-form-textarea v-model="mensaje" rows="3" />
    </b-form-group>
  </b-modal>
</template>

<script>
import {
  BModal, BFormCheckbox, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'

export default {
  components: {
    BModal, BFormCheckbox, BFormGroup, BFormTextarea,
  },
  props: {
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      activo: false,
      mensaje: '',
    }
  },
  methods: {
    async cargar() {
      if (!this.$store.state.maintenance.loaded) {
        await this.$store.dispatch('maintenance/fetch')
      }
      this.activo = this.$store.state.maintenance.active
      this.mensaje = this.$store.state.maintenance.message
    },
    async guardar() {
      try {
        await this.$store.dispatch('maintenance/setMaintenance', {
          activo: this.activo,
          mensaje: this.mensaje,
        })
        this.$emit('closeModal')
      } catch (e) {
        console.error('Error guardando mantenimiento:', e)
      }
    },
  },
}
</script>
